import { ResponsesTreasuryWithdrawGetResponse } from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { objectIsEmpty } from '../../../utils/objectIsEmpty';
import { DirectTreasuryWithdrawAssetNormalized } from '../types';

export const normalizeDirectTreasuryWithdrawAsset = (
  data: ResponsesTreasuryWithdrawGetResponse
): DirectTreasuryWithdrawAssetNormalized => {
  if (objectIsEmpty(data)) {
    throw new Error('No treasury found');
  }

  return {
    ...data,
    productNameNormalized: data.titleName || '--',
    maturityDateFormatted: Utils.Mask.DateFormat(data.maturityDate, 'dd/MM/yyyy'),
    indexNormalized: data.indexer || '--',
    availableQuantityNormalized: data.balanceQuantity.toString(),
    sellTaxNormalized: Utils.Mask.Percentage(data.saleFeeValue),
    unitPriceNormalized: Utils.Mask.Money(data.saleValue),
    minValueNormalized: data.minimumSaleValue,
    maxValueNormalized: data.maximumSaleValue,
  };
};
